import React from 'react';
import Project from '../../../Project/Project';
import About from '../About/About';
import Baner from '../Baner/Baner';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import MySkill from '../MySkill/MySkill';
import Service from '../Service/Service';

const Home = () => {
    return (
        <div>
            <Header/>
            <Baner></Baner>
            <About></About>
            <Service></Service>
            <MySkill></MySkill>
            <Project></Project>
            <Footer></Footer>
            
        </div>
    );
};

export default Home;